export default "__VITE_ASSET__C0vkIl9j__"